import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { GetOutputForecastForReceiptResponseResult } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';
import { OutputForecastForReceiptExcelData } from '../domains/entities/forecastForReceiptResponse';
import { GetOutputForecastForReceiptExcelDataAdapter } from '../adapter/GetOutputForecastForReceiptExcelDataAdapter';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 受領用内示エクセルテンプレートとエクセルに書き込む情報を取得するUseCase
 */
export class GetOutputForecastForReceiptExcelDataUseCase {
  private repository: IForecastForReceiptRepository;

  /**
   * コンストラクタ
   * @param repository - 受領用内示情報の永続化の責務を負うクラス
   */
  constructor(repository: IForecastForReceiptRepository) {
    this.repository = repository;
  }

  /**
   * サンプルエクセルを取得する
   * @param forecastForReceiptResponsibleUserId - 受領用内示担当者ユーザID
   */
  public Execute = async (
    forecastForReceiptResponsibleUserId: string
  ): Promise<INetworkResult<OutputForecastForReceiptExcelData, IError>> => {
    const result = await this.repository.getOutputForecastForReceipt(forecastForReceiptResponsibleUserId);
    switch (result.status.type) {
      case 'success':
        break;
      case 'error':
        return {
          status: {
            type: 'error',
            error: result.status.error,
          },
        };
    }

    // ここでアダプタを使ってExcelをダウンロードする
    const data = await GetOutputForecastForReceiptExcelDataAdapter.adaptForResponse(
      result.status.data as GetOutputForecastForReceiptResponseResult
    );

    return {
      status: {
        type: 'success',
        data: data,
      },
    };
  };
}
